import { render, staticRenderFns } from "./my-idea.vue?vue&type=template&id=7922abea&scoped=true&"
import script from "./my-idea.vue?vue&type=script&lang=js&"
export * from "./my-idea.vue?vue&type=script&lang=js&"
import style0 from "./my-idea.vue?vue&type=style&index=0&id=7922abea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7922abea",
  null
  
)

export default component.exports